// DEMO WRAPPER - REMOVE IN PRODUCTION
// This wrapper provides demo functionality for portrait ratio testing
// To disable: Comment out the import and usage in the main component
// To enable: Uncomment the import and usage

import React, { ReactNode } from 'react';
import { applyRatioStyles, getRatioStyles } from './DemoRatioToggle';
import { useDemoRatio } from '@/contexts/DemoContext';

// Custom hook to safely use demo context
const useSafeDemoRatio = () => {
    try {
        return useDemoRatio();
    } catch (error) {
        // Demo context not available, return default values
        return {
            portraitRatio: 'freestyle' as const,
            setPortraitRatio: () => { },
            isDemoMode: false
        };
    }
};

interface DemoWrapperProps {
    children: ReactNode;
}

export default function DemoWrapper({ children }: DemoWrapperProps) {
    const { portraitRatio } = useSafeDemoRatio();

    const styles = getRatioStyles(portraitRatio);
    const containerStyles = applyRatioStyles(portraitRatio);

    return (
        <div className="relative h-full min-h-0">
            {/* Main Content with Applied Ratio Styles */}
            <div
                style={containerStyles}
                className={`h-full min-h-0 transition-all duration-300 ease-in-out ${styles.containerClass}`}
            >
                {children}
            </div>
        </div>
    );
}

// DEMO UTILITY COMPONENT FOR INDIVIDUAL PAGES
export function DemoPageWrapper({ children }: { children: ReactNode }) {
    const { portraitRatio } = useSafeDemoRatio();

    const containerStyles = applyRatioStyles(portraitRatio);

    return (
        <div
            style={containerStyles}
            className="transition-all duration-300 ease-in-out"
        >
            {children}
        </div>
    );
}
